var _process$env;
import { createI18n } from 'vue-i18n';
import en from './lang/en.json';
import ru from './lang/ru.json';
import tw from './lang/tw.json';
import de from './lang/de.json';
import fr from './lang/fr.json';
import ko from './lang/ko.json';
import zh from './lang/zh.json';
import br from './lang/br.json';
import th from './lang/th.json';
import jp from './lang/ja.json';
const langs = ['en', 'ru', 'tw', 'de', 'fr', 'ko', 'br', 'th', 'jp'];
const AREA = ((_process$env = process.env) === null || _process$env === void 0 ? void 0 : _process$env.VUE_APP_AREA) || 'global';
const setInfoLanguage = function () {
  if (window.location.href.includes('/shinsangokushi') || window.location.href.includes('/shinsangokushinew')) {
    return 'jp';
  }
  const languageData = localStorage.getItem('__mall_language__');
  let lang = 'en';
  if (languageData) {
    try {
      lang = JSON.parse(languageData).currentLanguage.key;
    } catch (e) {
      lang = navigator.language.slice(0, 2).toLowerCase();
    }
  } else {
    lang = navigator.language.slice(0, 2).toLowerCase();
  }

  // 不在语言列表的，默认第一个语言
  if (!langs.includes(lang)) {
    lang = langs[0];
  }
  // 国内商城，固定为zh
  if (AREA === 'cn') {
    lang = 'zh';
  }
  return lang;
};
const i18n = createI18n({
  locale: setInfoLanguage(),
  fallbackLocale: 'en',
  legacy: false,
  messages: {
    en,
    ru,
    tw,
    de,
    fr,
    ko,
    zh,
    br,
    jp,
    th
  }
});
const setupI18n = function (app) {
  app.use(i18n);
};
export { setupI18n, langs };
export default i18n;